import React from "react";
import ChatCore from "../../shared/chat/ChatCore";

export default function ChatProvider() {
    return (
        <ChatCore
            activeRole="PROVIDER"
            canRateProvider={false}
            showEmotionRing={false}
            fetchSuggestionsEnabled={false}
        />
    );
}
